"use client";
import React, { useState } from "react";
import Image from "next/image";
import { Button } from "@mui/material";
import { useRouter } from "next/navigation";
import ccLogo from "../../../assets/icons/Cycle-Circle-Logo-Orange-1.png";
import HeaderWhatsApp from "@/middleware/HeaderWhatsapp";
import MobileViewMyDiscount from "./MobileViewMyDiscount";

const MobileHeader: React.FC = () => {
  const router = useRouter();
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => setOpen(true);
  const handleClose = (): void => setOpen(false);

  return (
    <div className="fixed h-[60px] top-0 left-0 w-full bg-gradient-to-b from-black-1 via-black-1/90 to-black-1/80 z-50 flex items-center justify-between py-3 px-4">
      {/* Website Logo (Left) */}
      <Image
        quality={50}
        unoptimized
        src={ccLogo}
        alt="Cycle Circle Logo"
        width={55}
        height={45}
        priority
        className="cursor-pointer"
        onClick={() => router.push("/")}
      />

      {/* Right Side - WhatsApp & Discount Button */}
      <div className="flex items-center gap-3">

        <HeaderWhatsApp/>

        <Button
          variant="contained"
          sx={{
            background: "#41a1e6",
            color: "#fff",
            padding: "6px 15px", // Slightly increased padding
            borderRadius: "50px",
            fontWeight: "600",
            fontSize: "14px", // Slightly bigger font for visibility
            textTransform: "capitalize",
            letterSpacing: "0.5px",
            minWidth: "auto",
            boxShadow: "0px 0px 1px rgba(74, 144, 226, 0.5)", // Soft blue shadow for depth
            transition: "all 0.3s ease-in-out",
            "&:hover": {
              background:
                "linear-gradient(to bottom, #5AA7FF 0%, #3A4D6A 100%)", // Slightly lighter hover effect
              boxShadow: "0px 6px 16px rgba(74, 144, 226, 0.7)",
            },
          }}
          onClick={handleOpen}
        >
          View Discount
        </Button>
      </div>

      {/* Discount Modal */}
      <MobileViewMyDiscount open={open} handleClose={handleClose} />
    </div>
  );
};

export default MobileHeader;
